import React, { FC, SVGProps } from 'react';

import styles from './SpinnerMini.module.scss';

const SpinnerMini: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    fill="none"
    viewBox="0 0 15 15"
    data-testid="spinner"
    preserveAspectRatio="xMinYMin meet"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.spinner}
    {...props}
  >
    <rect opacity="0.5" width="15" height="15" rx="7.5" fill="#98A2AF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.55456 4.1254C7.85396 4.1254 8.12614 4.18202 8.39832 4.23865C6.92856 4.60671 5.83985 5.96573 5.81263 7.60787C5.81263 8.08919 5.43158 8.48557 4.96888 8.48557C4.50618 8.48557 4.12513 8.08919 4.12513 7.60787C4.15234 5.65429 5.67654 4.09708 7.55456 4.1254ZM10.0312 6.54276C10.494 6.54276 10.875 6.93914 10.875 7.42046C10.8478 9.34573 9.32359 10.9029 7.44556 10.8746C7.14617 10.8746 6.87399 10.818 6.60181 10.7614C8.07157 10.3933 9.16028 9.03429 9.1875 7.39215C9.1875 6.93914 9.56855 6.54276 10.0312 6.54276Z"
      fill="white"
    />
  </svg>
);

export default SpinnerMini;
